module.exports = __webpack_public_path__ + "img/hr-H-B-1-load-standup-shadow.de64024c.png";